import { AgencyService } from './../../../../api/agency.service';
import { Component, Input, OnInit, Inject } from '@angular/core';
import { MenuLink } from '../menu-link.model';
import { DOCUMENT } from '@angular/platform-browser';
import { LocaleAwareBaseComponent } from './../../../../seo/locale-aware-base.component';

@Component({
  selector: 'app-menu-container-base',
  templateUrl: './menu-container-base.component.html',
  styleUrls: ['./menu-container-base.component.scss']
})

export class MenuContainerBaseComponent extends LocaleAwareBaseComponent implements OnInit {
  @Input() links: MenuLink[];
  @Input() hasLogo: boolean = true;
  @Input() hasSocialLinks: boolean = true;
  @Input() hasPhoneNumber: boolean = false;
  @Input() currentRoute: string;
  public open: boolean;

  constructor(
    public agencyService: AgencyService,
    @Inject(DOCUMENT) public document: any
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.links || this.links.length === 0) {
      throw new Error('MenuContainerBaseComponent Error: Invalid links');
    }
  }

  public toggleMobileMenu(): void {
    this.open = !this.open;

    if (this.open) {
      this.document.body.classList.add('no-scroll');
    } else {
      this.document.body.classList.remove('no-scroll');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/menu/menu-container-base/menu-container-base.component.ts